import {
  BigDecimal,
  Docs,
  Ecuador,
  LogisticaGuiaEstado,
  LogisticaGuiaProformaEstado,
  LogisticaManifiestoProformaEstado,
  LogisticaTipoConversion,
  LogisticaTiposEntrega,
  LogisticaTiposFormaPago,
  TiposDocumento,
  TiposIdentificacion,
  __name,
  __publicField,
  estadoLogisticaManifiestoProformaDetalle,
  estadoMOVIMIENTOCABECERA,
  estadoUsuario,
  logisticaManifiestoDetalleEstado,
  logisticaManifiestoEstado
} from "../chunk-7A3VL7FR.mjs";

// src/Entidades/ASIENTO_CABECERA.ts
var ASIENTO_CABECERA = class {
  constructor() {
    __publicField(this, "secuencial", 0);
    __publicField(this, "numero", 0);
    __publicField(this, "idDocumento", 0);
    __publicField(this, "concepto", "");
    __publicField(this, "fecha", /* @__PURE__ */ new Date());
    __publicField(this, "estado", "");
    __publicField(this, "USUARIO");
    __publicField(this, "fechaCreacion", /* @__PURE__ */ new Date());
    __publicField(this, "mc");
    __publicField(this, "MOVIMIENTOCABECERA");
    __publicField(this, "ic");
    __publicField(this, "IMPORTECABECERA");
    __publicField(this, "idAsientoCierre");
    __publicField(this, "cerrado", false);
    __publicField(this, "version");
    __publicField(this, "idUsuarioAnulacion");
    __publicField(this, "USUARIO_ANULACION");
    __publicField(this, "fechaAnulacion");
    __publicField(this, "idAmbienteContable");
  }
};
__name(ASIENTO_CABECERA, "ASIENTO_CABECERA");

// src/Entidades/BODEGA_FORMAPAGO.ts
var BODEGA_FORMAPAGO = class {
  constructor() {
    __publicField(this, "idBodega", 0);
    __publicField(this, "idFormaPago", 0);
    __publicField(this, "predeterminadaVenta", false);
    __publicField(this, "predeterminadaPlanAcumulativo", false);
    __publicField(this, "FORMAPAGO");
    __publicField(this, "BODEGA");
  }
};
__name(BODEGA_FORMAPAGO, "BODEGA_FORMAPAGO");

// src/Entidades/BODEGA.ts
var BODEGA = class {
  constructor() {
    __publicField(this, "id", 0);
    __publicField(this, "descripcion", "");
    __publicField(this, "direccion", "");
    /**Char 3*/
    __publicField(this, "codigo", "");
    __publicField(this, "precio", new BigDecimal(0));
    __publicField(this, "facturaMostrar", false);
    __publicField(this, "nombreComercial", "");
    __publicField(this, "verImagen", false);
    __publicField(this, "habilitado", false);
    __publicField(this, "idCiudad", 0);
    __publicField(this, "idBodegaReserva", 0);
    __publicField(this, "idPorcentaje", 0);
    __publicField(this, "modeloNegocio", 0);
    __publicField(this, "establecimientoAutorizado", false);
    __publicField(this, "forzarCentroCosto", false);
    __publicField(this, "esOrigenPedidoInterno", false);
    __publicField(this, "esCentroCosto", false);
  }
};
__name(BODEGA, "BODEGA");

// src/Entidades/CHEQUE.ts
var CHEQUE = class {
  constructor() {
    __publicField(this, "id", 0);
    __publicField(this, "banco", "");
    __publicField(this, "cuenta", "");
    __publicField(this, "ic");
    __publicField(this, "idCuenta", 0);
    __publicField(this, "idConductor", 0);
    __publicField(this, "idVehiculo", 0);
    __publicField(this, "idFormaPago", 0);
  }
};
__name(CHEQUE, "CHEQUE");

// src/Entidades/CIUDAD.ts
var CIUDAD = class {
  constructor() {
    __publicField(this, "id", 0);
    __publicField(this, "nombre", "");
    __publicField(this, "idProvincia", 0);
    __publicField(this, "permiteEntregarConManifiesto", false);
    __publicField(this, "idCiudadRecepcion");
    __publicField(this, "idPais", 0);
    __publicField(this, "habilitado", true);
    __publicField(this, "abreviatura", "");
  }
};
__name(CIUDAD, "CIUDAD");

// src/Entidades/CLIENTE_DIRECCION_PROFORMA.ts
var CLIENTE_DIRECCION_PROFORMA = class {
  constructor() {
    __publicField(this, "id", 0);
    __publicField(this, "idCliente", 0);
    __publicField(this, "establecimiento");
    __publicField(this, "idCiudad", 0);
    __publicField(this, "direccion", "");
    __publicField(this, "telefono1", "");
    __publicField(this, "telefono2");
    __publicField(this, "telefono3");
    __publicField(this, "RowVersion");
    __publicField(this, "descripcion", "");
    __publicField(this, "habilitado", true);
    __publicField(this, "CLIENTE");
    __publicField(this, "CIUDAD");
  }
};
__name(CLIENTE_DIRECCION_PROFORMA, "CLIENTE_DIRECCION_PROFORMA");

// src/Entidades/CLIENTE_DIRECCION.ts
var CLIENTE_DIRECCION = class {
  constructor() {
    __publicField(this, "id", 0);
    __publicField(this, "idCliente", 0);
    __publicField(this, "establecimiento");
    __publicField(this, "idCiudad", 0);
    __publicField(this, "direccion", "");
    __publicField(this, "descripcion", "");
    __publicField(this, "habilitado", true);
    __publicField(this, "telefono1", "");
    __publicField(this, "telefono2");
    __publicField(this, "telefono3");
    __publicField(this, "RowVersion");
    __publicField(this, "CLIENTE");
    __publicField(this, "CIUDAD");
  }
};
__name(CLIENTE_DIRECCION, "CLIENTE_DIRECCION");

// src/Entidades/CLIENTE.ts
var CLIENTE = class {
  constructor() {
    __publicField(this, "id", 0);
    __publicField(this, "idTipoIdentificacion", TiposIdentificacion.Cedula);
    __publicField(this, "cedula", "");
    __publicField(this, "razonSocial", "");
    __publicField(this, "nombreComercial", "");
    __publicField(this, "direccion", "");
    __publicField(this, "ciudad", 0);
    __publicField(this, "telefono", "");
    __publicField(this, "celular");
    __publicField(this, "email");
    __publicField(this, "habilitado", false);
    __publicField(this, "USUARIO");
    __publicField(this, "CLIENTE_DIRECCION_PROFORMA");
    __publicField(this, "logistica_RANGO_SEGURO");
  }
};
__name(CLIENTE, "CLIENTE");

// src/Entidades/CONFIGURACION_EMPRESA.ts
var CONFIGURACION_EMPRESA = class {
  constructor() {
    __publicField(this, "descripcion", "");
    __publicField(this, "valor", "");
    __publicField(this, "codigo", 0);
  }
};
__name(CONFIGURACION_EMPRESA, "CONFIGURACION_EMPRESA");

// src/Entidades/DOCUMENTO.ts
var DOCUMENTO = class {
  constructor() {
    __publicField(this, "id", 0);
    __publicField(this, "descripcion", "");
    __publicField(this, "numero", 0);
    __publicField(this, "tipo", TiposDocumento.noDefinido);
    __publicField(this, "modulo", "");
    __publicField(this, "abreviatura", "");
    __publicField(this, "generarAsiento", false);
  }
};
__name(DOCUMENTO, "DOCUMENTO");

// src/Entidades/FORMAPAGO.ts
var FORMAPAGO = class {
  constructor() {
    __publicField(this, "id", 0);
    __publicField(this, "descripcion", "");
    __publicField(this, "compra", 0);
    __publicField(this, "venta", 0);
    __publicField(this, "POS", false);
    __publicField(this, "idDocumentoSRI");
    __publicField(this, "idDocumentoBancoCompra");
    __publicField(this, "idDocumentoBancoVenta");
    __publicField(this, "cheque", false);
    __publicField(this, "idFormaPagoSRI");
    __publicField(this, "habilitado", false);
    __publicField(this, "tarjetaCreditoDebito");
    __publicField(this, "efectivo");
    __publicField(this, "fleteAlCobro");
    __publicField(this, "idTipoFormaPago", 0);
    __publicField(this, "abreviatura");
    __publicField(this, "devolucionDinero", false);
    __publicField(this, "TIPO_FORMA_PAGO");
  }
};
__name(FORMAPAGO, "FORMAPAGO");

// src/Entidades/IMPORTECABECERA.ts
var IMPORTECABECERA = class {
  constructor() {
    __publicField(this, "id", 0);
    __publicField(this, "fecha", /* @__PURE__ */ new Date());
    __publicField(this, "numeroDocumento", 0);
    __publicField(this, "idDocumento", 0);
    __publicField(this, "DOCUMENTO");
    __publicField(this, "tipo");
    __publicField(this, "estado", "");
    __publicField(this, "fechaCreacion", /* @__PURE__ */ new Date());
    __publicField(this, "idUsuario", 0);
    __publicField(this, "USUARIO");
    __publicField(this, "fechaAnulacion");
    __publicField(this, "serie1");
    __publicField(this, "serie2");
    __publicField(this, "autorizacion");
    __publicField(this, "idMovimientoRetenido");
    //MOVIMIENTO_RETENIDO?: MOVIMIENTOCABECERA;
    __publicField(this, "idUsuarioAnulacion");
    __publicField(this, "USUARIO_ANULACION");
    __publicField(this, "idCliente");
    __publicField(this, "CLIENTE");
    __publicField(this, "idProveedor");
    __publicField(this, "cerrado", false);
    __publicField(this, "observacion");
    __publicField(this, "apiKey");
    __publicField(this, "claveAcceso");
    __publicField(this, "fechaAutorizacion");
    __publicField(this, "total");
    __publicField(this, "idBodega");
    //BODEGA?: BODEGA;
    __publicField(this, "idFacturaGenerada");
    __publicField(this, "retencionAsumida");
    __publicField(this, "estadoPagoVariosProveedores");
    __publicField(this, "idClienteDireccion");
    __publicField(this, "CLIENTE_DIRECCION");
    __publicField(this, "idTipoPago");
    __publicField(this, "idClienteVisitaObservacion");
    __publicField(this, "CHEQUES");
    __publicField(this, "SIENTO_CABECERAS");
    //ANTICIPOS?: ANTICIPO[];
    __publicField(this, "IMPORTEDETALLES");
    __publicField(this, "saldoAnterior", new BigDecimal(0));
  }
};
__name(IMPORTECABECERA, "IMPORTECABECERA");

// src/Entidades/IMPORTEDETALLE.ts
var IMPORTEDETALLE = class {
  constructor() {
    __publicField(this, "id", 0);
    __publicField(this, "cabecera", 0);
    __publicField(this, "IMPORTECABECERA");
    __publicField(this, "idMovimientoCabecera");
    __publicField(this, "movimiento");
    // MOVIMIENTOCABECERA?: MOVIMIENTOCABECERA;
    __publicField(this, "entidadFinanciera");
    __publicField(this, "monto", new BigDecimal(0));
    __publicField(this, "numeroCuenta");
    __publicField(this, "numeroCheque");
    __publicField(this, "fechaCheque");
    __publicField(this, "formapago");
    __publicField(this, "FORMAPAGO");
    __publicField(this, "observacion");
    __publicField(this, "codigoRet");
    //porcentajeRetencion?: number;
    //baseImponibleRetencion?: number;
    //impuestoRetencion?: string;
    __publicField(this, "idAnticipo");
    //ANTICIPO?: ANTICIPO;
    __publicField(this, "idLetra");
    //LETRA?: LETRA;
    __publicField(this, "cxc_capital");
    __publicField(this, "cxc_interes");
    __publicField(this, "cxc_seguro");
    __publicField(this, "cxc_otros");
    __publicField(this, "idTipoTarjeta");
    //   TIPO_TARJETA?: LISTAS;
    __publicField(this, "idMarcaTarjeta");
    //    MARCA_TARJETA?: LISTAS;
    __publicField(this, "idBancoTarjeta");
    //    BANCO_TARJETA?: LISTAS;
    __publicField(this, "devolucionDinero", false);
    __publicField(this, "senae");
    __publicField(this, "depositadoSenae");
    __publicField(this, "numeroSenae");
    __publicField(this, "fechaSenae");
  }
};
__name(IMPORTEDETALLE, "IMPORTEDETALLE");

// src/Entidades/logistica_CONTENIDO.ts
var logistica_CONTENIDO = class {
  constructor() {
    __publicField(this, "id", 0);
    __publicField(this, "idCliente");
    __publicField(this, "descripcion", "");
    __publicField(this, "precio", new BigDecimal(0));
    __publicField(this, "idCiudadOrigen");
    __publicField(this, "idCiudadDestino");
    __publicField(this, "idTipoIva", 0);
    __publicField(this, "esBulto", true);
    __publicField(this, "cantidadMinima");
    __publicField(this, "cantidadMaxima");
    __publicField(this, "idTipoContenido", 0);
    __publicField(this, "TIPO_IVA");
    __publicField(this, "idTipoDestino");
    __publicField(this, "idTarifario", 0);
    __publicField(this, "idTipoMedida", 0);
    __publicField(this, "habilitado", true);
  }
};
__name(logistica_CONTENIDO, "logistica_CONTENIDO");

// src/Entidades/logistica_CONVERSION.ts
var logistica_CONVERSION = class {
  constructor() {
    __publicField(this, "id", 0);
    __publicField(this, "idGuia", 0);
    __publicField(this, "idTipoConversion", LogisticaTipoConversion.Flete_al_cobro_en_gu\u00EDa);
    __publicField(this, "idEstadoConversion", 0);
    __publicField(this, "idUsuarioSolicitud", 0);
    __publicField(this, "fechaHoraSolicitud", /* @__PURE__ */ new Date());
    __publicField(this, "idUsuarioAprobacionRechazo");
    __publicField(this, "fechaHoraAprobacionRechazo");
    __publicField(this, "motivoRechazo");
  }
};
__name(logistica_CONVERSION, "logistica_CONVERSION");

// src/Entidades/logistica_GUIA.ts
var logistica_GUIA = class {
  constructor() {
    __publicField(this, "id", 0);
    __publicField(this, "idDocumento", Docs.GUIA_TRANSPORTE);
    __publicField(this, "serie1", "");
    __publicField(this, "serie2", "");
    __publicField(this, "numeroDocumento", 0);
    __publicField(this, "fechaEmision", /* @__PURE__ */ new Date());
    __publicField(this, "idRemitente", 0);
    __publicField(this, "idDestinatario", 0);
    __publicField(this, "observacion", "");
    __publicField(this, "idCiudadOrigen", 0);
    __publicField(this, "idCiudadDestino", 0);
    __publicField(this, "entregaUrgente", false);
    __publicField(this, "tipo", LogisticaTiposFormaPago.Credito);
    __publicField(this, "tipoEntrega", LogisticaTiposEntrega.Domicilio);
    __publicField(this, "iva", new BigDecimal(0));
    __publicField(this, "total", new BigDecimal(0));
    __publicField(this, "LS_usuarioCreacion", "");
    __publicField(this, "fechaEntrega");
    __publicField(this, "longitud");
    __publicField(this, "latitud");
    __publicField(this, "LS_usuarioEntrega");
    __publicField(this, "estado", LogisticaGuiaEstado.Planta);
    __publicField(this, "idFactura");
    __publicField(this, "recibida", false);
    __publicField(this, "novedadesRecepcion");
    __publicField(this, "fechaRecepcion");
    __publicField(this, "entregada");
    __publicField(this, "novedadesEntrega");
    __publicField(this, "personaEntrega");
    __publicField(this, "fechaCobroEntrega");
    __publicField(this, "seguro", new BigDecimal(0));
    __publicField(this, "seguroPagado", false);
    __publicField(this, "valorDeclarado", new BigDecimal(0));
    __publicField(this, "LS_usuarioAnulacion", "");
    __publicField(this, "fechaAnulacion", /* @__PURE__ */ new Date());
    __publicField(this, "EstadoFacturacion", "N");
    __publicField(this, "LS_seleccionado", false);
    __publicField(this, "LS_usuarioRecepcion", "");
    __publicField(this, "direccionRemitente", "");
    __publicField(this, "telefonoRemitente", "");
    __publicField(this, "direccionDestinatario", "");
    __publicField(this, "telefonoDestinatario", "");
    __publicField(this, "estadoDocumento", "C");
    __publicField(this, "idVehiculo");
    __publicField(this, "transporte", new BigDecimal(0));
    __publicField(this, "ivaSeguro", new BigDecimal(0));
    __publicField(this, "idFacturaSeguro");
    __publicField(this, "idMotivoDevolucion");
    __publicField(this, "saldoPorPagar");
    __publicField(this, "estadoRecepcion", "C");
    __publicField(this, "bultos", new BigDecimal(0));
    __publicField(this, "domicilio", new BigDecimal(0));
    __publicField(this, "ivaPorcentaje", Ecuador.porcentajeIva);
    __publicField(this, "cancelarTrazabilidad", false);
    __publicField(this, "baseCero", new BigDecimal());
    __publicField(this, "baseIva");
    __publicField(this, "cantidad", new BigDecimal(0));
    __publicField(this, "idClienteDireccion");
    __publicField(this, "idRuta");
    __publicField(this, "solicitarConversion");
    __publicField(this, "motivoAnulacion");
    __publicField(this, "idBodegaOrigen");
    __publicField(this, "idBodegaDestino");
    __publicField(this, "entregadaConManifiesto");
    __publicField(this, "retiradaPorOficina");
    __publicField(this, "profundidad");
    __publicField(this, "alto");
    __publicField(this, "ancho");
    __publicField(this, "peso");
    __publicField(this, "idExterno");
    __publicField(this, "idUsuario");
    __publicField(this, "nombreDestinatario");
    __publicField(this, "FACTURA");
    __publicField(this, "CLIENTE_DESTINATARIO");
    __publicField(this, "CLIENTE_REMITENTE");
    __publicField(this, "CIUDAD_ORIGEN");
    __publicField(this, "CIUDAD_DESTINO");
    __publicField(this, "DOCUMENTO");
    __publicField(this, "logistica_GUIA_DETALLES");
    __publicField(this, "logistica_GUIA_FOTOS");
    __publicField(this, "logistica_MANIFIESTO_DETALLE");
    __publicField(this, "logistica_GUIA_GESTION");
    __publicField(this, "logistica_CONVERSION");
    __publicField(this, "logistica_MOTIVO_DEVOLUCION");
    __publicField(this, "logistica_GUIA_DOCUMENTO_RELACIONES");
  }
};
__name(logistica_GUIA, "logistica_GUIA");

// src/Entidades/logistica_GUIA_PROFORMA.ts
var logistica_GUIA_PROFORMA = class {
  constructor() {
    __publicField(this, "id");
    __publicField(this, "idDocumento", Docs.GUIA_TRANSPORTE);
    __publicField(this, "serie1", "");
    __publicField(this, "idUsuario", 0);
    __publicField(this, "serie2", "");
    __publicField(this, "numeroDocumento", 0);
    __publicField(this, "fechaEmision", /* @__PURE__ */ new Date());
    __publicField(this, "idRemitente", 0);
    __publicField(this, "idDestinatario", 0);
    __publicField(this, "estado", LogisticaGuiaProformaEstado.Liberado);
    __publicField(this, "total", new BigDecimal(0));
    __publicField(this, "observacion", "");
    __publicField(this, "tipo", LogisticaTiposFormaPago.Credito);
    __publicField(this, "LS_usuarioCreacion", "");
    __publicField(this, "LS_usuarioAnulacion");
    __publicField(this, "fechaAnulacion");
    __publicField(this, "idCiudadOrigen", 0);
    __publicField(this, "idCiudadDestino", 0);
    __publicField(this, "direccionRemitente", "");
    __publicField(this, "telefonoRemitente", "");
    __publicField(this, "direccionDestinatario", "");
    __publicField(this, "telefonoDestinatario", "");
    __publicField(this, "nombreDestinatario", "");
    __publicField(this, "documentosRelacionados", "");
    __publicField(this, "tipoEntrega", LogisticaTiposEntrega.Domicilio);
    __publicField(this, "bultos", new BigDecimal(0));
    __publicField(this, "ivaPorcentaje", Ecuador.porcentajeIva);
    __publicField(this, "baseCero", new BigDecimal(0));
    __publicField(this, "baseIva", new BigDecimal(0));
    __publicField(this, "iva", new BigDecimal(0));
    __publicField(this, "cantidad", new BigDecimal(0));
    __publicField(this, "idClienteDireccionProforma");
    __publicField(this, "motivoAnulacion");
    __publicField(this, "CLIENTE_DESTINATARIO");
    __publicField(this, "CLIENTE_REMITENTE");
    __publicField(this, "CIUDAD_ORIGEN");
    __publicField(this, "CIUDAD_DESTINO");
    __publicField(this, "logistica_GUIA_FOTO");
    __publicField(this, "logistica_GUIA_PROFORMA_DETALLE");
    __publicField(this, "seguro", new BigDecimal(0));
    __publicField(this, "seguroPagado", false);
    __publicField(this, "ivaSeguro");
    __publicField(this, "valorDeclarado");
    __publicField(this, "latitud");
    __publicField(this, "longitud");
    __publicField(this, "profundidad");
    __publicField(this, "alto");
    __publicField(this, "ancho");
    __publicField(this, "peso");
    __publicField(this, "fechaEntrega");
    __publicField(this, "LS_seleccionado", false);
  }
};
__name(logistica_GUIA_PROFORMA, "logistica_GUIA_PROFORMA");

// src/Entidades/logistica_GUIA_DETALLE.ts
var logistica_GUIA_DETALLE = class {
  constructor() {
    __publicField(this, "id", 0);
    __publicField(this, "idGuia", 0);
    __publicField(this, "cantidad", new BigDecimal(0));
    __publicField(this, "idContenido", 0);
    __publicField(this, "detalle", "");
    __publicField(this, "precio", new BigDecimal(0));
    __publicField(this, "total", new BigDecimal(0));
    __publicField(this, "subtotal", new BigDecimal(0));
    __publicField(this, "iva", new BigDecimal(0));
    __publicField(this, "seguro", false);
    __publicField(this, "bultos", 0);
    __publicField(this, "logistica_GUIA");
    __publicField(this, "logistica_CONTENIDO");
  }
};
__name(logistica_GUIA_DETALLE, "logistica_GUIA_DETALLE");

// src/Entidades/logistica_GUIA_FOTO.ts
var logistica_GUIA_FOTO = class {
  constructor() {
    __publicField(this, "idGuia", 0);
    __publicField(this, "id", 0);
    __publicField(this, "url", "");
  }
};
__name(logistica_GUIA_FOTO, "logistica_GUIA_FOTO");

// src/Entidades/logistica_GUIA_GESTION.ts
var logistica_GUIA_GESTION = class {
  constructor() {
    __publicField(this, "id", 0);
    __publicField(this, "idGuia", 0);
    __publicField(this, "fechaCreacion", /* @__PURE__ */ new Date());
    __publicField(this, "descripcion", "");
  }
};
__name(logistica_GUIA_GESTION, "logistica_GUIA_GESTION");

// src/Entidades/logistica_GUIA_PROFORMA_DETALLE.ts
var logistica_GUIA_PROFORMA_DETALLE = class {
  constructor() {
    __publicField(this, "id");
    __publicField(this, "idGuiaProforma");
    __publicField(this, "cantidad", new BigDecimal(0));
    __publicField(this, "idContenido", 0);
    __publicField(this, "detalle", "");
    __publicField(this, "precio", new BigDecimal(0));
    __publicField(this, "total", new BigDecimal(0));
    __publicField(this, "subtotal", new BigDecimal(0));
    __publicField(this, "iva", new BigDecimal(0));
    __publicField(this, "seguro", false);
    __publicField(this, "bultos", 0);
    __publicField(this, "logistica_GUIA_PROFORMA");
    __publicField(this, "logistica_CONTENIDO");
  }
};
__name(logistica_GUIA_PROFORMA_DETALLE, "logistica_GUIA_PROFORMA_DETALLE");

// src/Entidades/logistica_MANIFIESTO_DETALLE.ts
var logistica_MANIFIESTO_DETALLE = class {
  constructor() {
    __publicField(this, "id", "");
    __publicField(this, "estado", logisticaManifiestoDetalleEstado.Activo);
    __publicField(this, "observaciones", "");
    __publicField(this, "idGuia", 0);
    __publicField(this, "idManifiestoProforma", 0);
    __publicField(this, "logistica_MANIFIESTO");
    __publicField(this, "logistica_GUIA");
    __publicField(this, "logistica_GUIA_CONTENIDO");
  }
};
__name(logistica_MANIFIESTO_DETALLE, "logistica_MANIFIESTO_DETALLE");

// src/Entidades/logistica_MANIFIESTO.ts
var logistica_MANIFIESTO = class {
  constructor() {
    __publicField(this, "id", 0);
    __publicField(this, "idDocumento", Docs.MANIFIESTO_LOGISTICA);
    __publicField(this, "idUsuario", 0);
    __publicField(this, "numeroDocumento", 0);
    __publicField(this, "serie1", "");
    __publicField(this, "serie2", "");
    __publicField(this, "idConductor", 0);
    __publicField(this, "idVehiculo", 0);
    __publicField(this, "fechaEmision", /* @__PURE__ */ new Date());
    __publicField(this, "LS_usuarioCreacion", "");
    __publicField(this, "LS_usuarioAnulacion");
    __publicField(this, "fechaAnulacion");
    __publicField(this, "estado", logisticaManifiestoEstado.Activo);
    __publicField(this, "costoFlete");
    __publicField(this, "saldo");
    __publicField(this, "idCiudadOrigen", 0);
    __publicField(this, "idCiudadDestino", 0);
    __publicField(this, "valorBajada");
    __publicField(this, "idOrdenTrabajo");
    __publicField(this, "observacion");
    __publicField(this, "idRuta");
    __publicField(this, "idOperador");
    __publicField(this, "idBodegaOrigen", 0);
    __publicField(this, "idBodegaDestino", 0);
    __publicField(this, "CLIENTE_DESTINATARIO");
    __publicField(this, "CLIENTE_REMITENTE");
    __publicField(this, "CIUDAD_ORIGEN");
    __publicField(this, "CIUDAD_DESTINO");
    __publicField(this, "logistica_MANIFIESTO_DETALLE");
  }
};
__name(logistica_MANIFIESTO, "logistica_MANIFIESTO");

// src/Entidades/logistica_MANIFIESTO_PROFORMA.ts
var logistica_MANIFIESTO_PROFORMA = class {
  constructor() {
    __publicField(this, "id", 0);
    __publicField(this, "serie1", "");
    __publicField(this, "serie2", "");
    __publicField(this, "numeroDocumento", 0);
    __publicField(this, "fechaEmision", /* @__PURE__ */ new Date());
    __publicField(this, "idUsuario", 0);
    __publicField(this, "idDocumento", Docs.MANIFIESTO_LOGISTICA);
    __publicField(this, "LS_usuarioCreacion", "");
    __publicField(this, "LS_usuarioAnulacion");
    __publicField(this, "fechaAnulacion");
    __publicField(this, "estado", LogisticaManifiestoProformaEstado.Pendiente);
    __publicField(this, "idCiudadOrigen", 0);
    __publicField(this, "idCiudadDestino", 0);
    __publicField(this, "observacion", "");
    __publicField(this, "CLIENTE_DESTINATARIO");
    __publicField(this, "CLIENTE_REMITENTE");
    __publicField(this, "CIUDAD_ORIGEN");
    __publicField(this, "CIUDAD_DESTINO");
    __publicField(this, "logistica_MANIFIESTO_PROFORMA_DETALLE");
  }
};
__name(logistica_MANIFIESTO_PROFORMA, "logistica_MANIFIESTO_PROFORMA");

// src/Entidades/logistica_MANIFIESTO_PROFORMA_DETALLE.ts
var logistica_MANIFIESTO_PROFORMA_DETALLE = class {
  constructor() {
    __publicField(this, "id");
    __publicField(this, "idManifiestoProforma", 0);
    __publicField(this, "idGuiaProforma", 0);
    __publicField(this, "estado", estadoLogisticaManifiestoProformaDetalle.Pendiente);
    __publicField(this, "observaciones", "");
    __publicField(this, "logistica_MANIFIESTO_PROFORMA");
    __publicField(this, "logistica_GUIA_PROFORMA");
  }
};
__name(logistica_MANIFIESTO_PROFORMA_DETALLE, "logistica_MANIFIESTO_PROFORMA_DETALLE");

// src/Entidades/logistica_RANGO_GUIA.ts
var logistica_RANGO_GUIA = class {
  constructor() {
    __publicField(this, "id", 0);
    __publicField(this, "idDocumento", Docs.GUIA_TRANSPORTE);
    __publicField(this, "serie1", "");
    __publicField(this, "serie2", "");
    __publicField(this, "numero", 0);
    __publicField(this, "idCliente");
    __publicField(this, "inicio");
    __publicField(this, "fin");
    __publicField(this, "idTipoUsuario");
    __publicField(this, "idBodega");
  }
};
__name(logistica_RANGO_GUIA, "logistica_RANGO_GUIA");

// src/Entidades/logistica_RANGO_SEGURO.ts
var logistica_RANGO_SEGURO = class {
  constructor() {
    __publicField(this, "id", 0);
    __publicField(this, "nivel", 0);
    __publicField(this, "desde", new BigDecimal(0));
    __publicField(this, "hasta", new BigDecimal(0));
    __publicField(this, "porcentaje", new BigDecimal(0));
    __publicField(this, "idCliente", 0);
    __publicField(this, "CLIENTE");
  }
};
__name(logistica_RANGO_SEGURO, "logistica_RANGO_SEGURO");

// src/Entidades/MOTIVO_DEVOLUCION.ts
var MOTIVO_DEVOLUCION = class {
  constructor() {
    __publicField(this, "id", 0);
    __publicField(this, "descripcion", "");
    __publicField(this, "habilitado", true);
  }
};
__name(MOTIVO_DEVOLUCION, "MOTIVO_DEVOLUCION");

// src/Entidades/MOVIMIENTOCABECERA.ts
var MOVIMIENTOCABECERA = class {
  constructor() {
    __publicField(this, "id", 0);
    __publicField(this, "idMovimientoCabeceraModificado", 0);
    //MODIFICADO?: MOVIMIENTOCABECERA;
    __publicField(this, "fechaEmision", /* @__PURE__ */ new Date());
    __publicField(this, "idDocumento", Docs.FACTURA);
    __publicField(this, "DOCUMENTO");
    __publicField(this, "numeroDocumento", 0);
    __publicField(this, "baseCero", new BigDecimal(0));
    __publicField(this, "baseIva", new BigDecimal(0));
    __publicField(this, "iva", new BigDecimal(0));
    __publicField(this, "ivaPorcentaje", Ecuador.porcentajeIva);
    __publicField(this, "descuentoTotal", new BigDecimal(0));
    __publicField(this, "total", new BigDecimal(0));
    __publicField(this, "estado", estadoMOVIMIENTOCABECERA.Activo);
    __publicField(this, "observacion", "");
    __publicField(this, "saldoPorPagar", new BigDecimal(0));
    __publicField(this, "fechaCreacion", /* @__PURE__ */ new Date());
    __publicField(this, "pagaIva", true);
    __publicField(this, "diasPlazo");
    __publicField(this, "fechaAnulacion");
    __publicField(this, "serie1");
    __publicField(this, "serie2");
    __publicField(this, "IMPRESION_RUC", "");
    __publicField(this, "IMPRESION_RAZONSOCIAL", "");
    __publicField(this, "IMPRESION_DIRECCION", "");
    __publicField(this, "IMPRESION_TELEFONO", "");
    __publicField(this, "autorizacion");
    //idTipoComprobante?: number;
    __publicField(this, "idUsuarioAnulacion");
    __publicField(this, "USUARIO_ANULACION");
    __publicField(this, "idBodega", 0);
    __publicField(this, "BODEGA");
    //idTipoIdentificacion?: number;
    //TIPO_IDENTIFICACION?: DOCUMENTOSRI;
    __publicField(this, "idCliente");
    __publicField(this, "CLIENTE");
    //idTipoClienteListaPrecios?: number;
    //TIPO_CLIENTE_LISTA_PRECIOS?: TIPOCLIENTE_LISTA_PRECIOS;
    //idVendedor?: number;
    //VENDEDOR?: VENDEDOR;
    __publicField(this, "cerrado", false);
    __publicField(this, "idCuentaCredito");
    //CUENTA?: CUENTA;
    __publicField(this, "fechaAutorizacion");
    __publicField(this, "claveAcceso");
    __publicField(this, "costoTotal");
    __publicField(this, "baseNoIVA");
    __publicField(this, "montoICE");
    __publicField(this, "tipoEmision");
    __publicField(this, "idRuta");
    __publicField(this, "propina");
    __publicField(this, "fechaVencimiento");
    __publicField(this, "idClienteDireccion");
    //CLIENTE_DIRECCION?: CLIENTE_DIRECCION;
    __publicField(this, "descripcionArticuloMasCostoso");
    __publicField(this, "countMD");
    __publicField(this, "sumCantidadMD");
    __publicField(this, "admiteRetencion");
    __publicField(this, "fechaUltimoPago");
    __publicField(this, "diasPago");
    __publicField(this, "vencidoDesde");
    __publicField(this, "idClienteVisitaObservacion");
    //CLIENTE_VISITA_OBSERVACION?: CLIENTE_VISITA_OBSERVACION;
    //LETRAS?: LETRA[];
    //MOVIMIENTODETALLES?: MOVIMIENTODETALLE[];
    __publicField(this, "NOTAS_CREDITO");
    __publicField(this, "RETENCIONES");
    __publicField(this, "IMPORTEDETALLES_PAGOS");
    __publicField(this, "IMPORTEDETALLES_CRUCES");
    //ASIENTO_CABECERAS?: ASIENTO_CABECERA[];
    //ASIENTO_DETALLES?: ASIENTO_DETALLE[];
    __publicField(this, "CHEQUE");
  }
};
__name(MOVIMIENTOCABECERA, "MOVIMIENTOCABECERA");

// src/Entidades/NOTIFICACION.ts
var NOTIFICACION = class {
  constructor() {
    __publicField(this, "id", 0);
    __publicField(this, "descripcion", "");
    __publicField(this, "cuerpoMensaje", "");
    __publicField(this, "idBodega", 0);
    __publicField(this, "NOTIFICACION_USUARIO");
  }
};
__name(NOTIFICACION, "NOTIFICACION");

// src/Entidades/NOTFICACION_USUARIO.ts
var NOTIFICACION_USUARIO = class {
  constructor() {
    __publicField(this, "idUsuario", 0);
    __publicField(this, "idNotificacion", 0);
    __publicField(this, "USUARIO");
    __publicField(this, "NOTIFICACION");
  }
};
__name(NOTIFICACION_USUARIO, "NOTIFICACION_USUARIO");

// src/Entidades/TIPO_FORMA_PAGO.ts
var TIPO_FORMA_PAGO = class {
  constructor() {
    __publicField(this, "id", 0);
    __publicField(this, "descripcion", "");
    __publicField(this, "idTipoPago");
  }
};
__name(TIPO_FORMA_PAGO, "TIPO_FORMA_PAGO");

// src/Entidades/TIPO_IVA.ts
var TIPO_IVA = class {
  constructor() {
    __publicField(this, "id", 0);
    __publicField(this, "descripcion", "");
    __publicField(this, "porcentaje");
    __publicField(this, "habilitado", true);
  }
};
__name(TIPO_IVA, "TIPO_IVA");

// src/Entidades/USUARIO_CLIENTE.ts
var USUARIO_CLIENTE = class {
  constructor() {
    __publicField(this, "idUsuario", 0);
    __publicField(this, "idCliente", 0);
    __publicField(this, "habilitado", true);
    __publicField(this, "CLIENTE");
    __publicField(this, "USUARIO");
  }
};
__name(USUARIO_CLIENTE, "USUARIO_CLIENTE");

// src/Entidades/USUARIO.ts
var USUARIO = class {
  constructor() {
    __publicField(this, "id", 0);
    __publicField(this, "usuario", "");
    __publicField(this, "password", "");
    __publicField(this, "aperturaCaja", new BigDecimal(0));
    __publicField(this, "estado", estadoUsuario.Activo);
    __publicField(this, "descuentoMaximo", new BigDecimal());
    __publicField(this, "habilitado", true);
    __publicField(this, "mostrarTodosVendedores", false);
    __publicField(this, "mostrarTodasBodegas", false);
    __publicField(this, "mostrarTodosClientes", false);
    __publicField(this, "email");
    __publicField(this, "idVendedor");
    __publicField(this, "idBodega");
    __publicField(this, "codigo");
    __publicField(this, "idTipoUsuario");
    __publicField(this, "idConductor");
    __publicField(this, "uuid");
    __publicField(this, "nombre");
    __publicField(this, "direccion");
    __publicField(this, "telefono");
    __publicField(this, "idCiudad");
    __publicField(this, "CIUDAD");
  }
};
__name(USUARIO, "USUARIO");

// src/Entidades/LISTAS.ts
var LISTAS = class {
  constructor() {
    __publicField(this, "id", 0);
    __publicField(this, "descripcion", "");
    __publicField(this, "valor", "");
    __publicField(this, "tabla", "");
    __publicField(this, "idCuenta", 0);
    __publicField(this, "valorPorCupon");
    __publicField(this, "habilitado", true);
  }
};
__name(LISTAS, "LISTAS");

// src/Entidades/logistica_MOTIVO_DEVOLUCION.ts
var logistica_MOTIVO_DEVOLUCION = class {
  constructor() {
    __publicField(this, "id", 0);
    __publicField(this, "descripcion", "");
    __publicField(this, "habilitado", true);
  }
};
__name(logistica_MOTIVO_DEVOLUCION, "logistica_MOTIVO_DEVOLUCION");

// src/Vistas/logistica_TrackingGuia.ts
var logistica_TrackingGuia = class {
  constructor() {
    __publicField(this, "idGuia", 0);
    __publicField(this, "fecha");
    __publicField(this, "descripcion", "");
  }
};
__name(logistica_TrackingGuia, "logistica_TrackingGuia");

// src/Vistas/LogisticaContenidoDisponible.ts
var LogisticaContenidoDisponible = class {
  constructor(init) {
    __publicField(this, "id");
    __publicField(this, "descripcion");
    __publicField(this, "precio");
    __publicField(this, "idTipoIva");
    __publicField(this, "esBulto");
    __publicField(this, "idTipoMedida");
    __publicField(this, "idTarifario");
    __publicField(this, "cantidadMaxima");
    __publicField(this, "listaPrecio");
    __publicField(this, "esServicio");
    __publicField(this, "idTipoContenido");
    Object.assign(this, init);
    this.precio = new BigDecimal(init.precio);
    if ((init == null ? void 0 : init.cantidadMaxima) === null) {
      this.cantidadMaxima = new BigDecimal(0);
    } else {
      this.cantidadMaxima = new BigDecimal(init.cantidadMaxima);
    }
  }
};
__name(LogisticaContenidoDisponible, "LogisticaContenidoDisponible");
export {
  ASIENTO_CABECERA,
  BODEGA,
  BODEGA_FORMAPAGO,
  CHEQUE,
  CIUDAD,
  CLIENTE,
  CLIENTE_DIRECCION,
  CLIENTE_DIRECCION_PROFORMA,
  CONFIGURACION_EMPRESA,
  DOCUMENTO,
  FORMAPAGO,
  IMPORTECABECERA,
  IMPORTEDETALLE,
  LISTAS,
  LogisticaContenidoDisponible,
  MOTIVO_DEVOLUCION,
  MOVIMIENTOCABECERA,
  NOTIFICACION,
  NOTIFICACION_USUARIO,
  TIPO_FORMA_PAGO,
  TIPO_IVA,
  USUARIO,
  USUARIO_CLIENTE,
  logistica_CONTENIDO,
  logistica_CONVERSION,
  logistica_GUIA,
  logistica_GUIA_DETALLE,
  logistica_GUIA_FOTO,
  logistica_GUIA_GESTION,
  logistica_GUIA_PROFORMA,
  logistica_GUIA_PROFORMA_DETALLE,
  logistica_MANIFIESTO,
  logistica_MANIFIESTO_DETALLE,
  logistica_MANIFIESTO_PROFORMA,
  logistica_MANIFIESTO_PROFORMA_DETALLE,
  logistica_MOTIVO_DEVOLUCION,
  logistica_RANGO_GUIA,
  logistica_RANGO_SEGURO,
  logistica_TrackingGuia
};
